import React, { useEffect, useRef, useContext } from 'react'
import mapboxgl from 'mapbox-gl'
import { AppContext } from './App'

const Map = () => {
  const {
    loading,
    map,
    setMap,
    animateMapToLocation,
    mapFeatures,
    setFeature,
    unsetFeature,
  } = useContext(AppContext)
  const mapEl = useRef()

  useEffect(() => {
    mapboxgl.accessToken = 'pk.eyJ1IjoicHBlcm96em8iLCJhIjoiY2s3eDg1MnY3MDdydzNnb3NrcWxqdjFsZSJ9.4gWHGYU0acT2CqZNMxBfKw'

    const bounds = [
      [0, 35],
      [28, 50]
    ]

    const newMap = new mapboxgl.Map({
      container: mapEl.current,
      style: 'mapbox://styles/pperozzo/ck7x892fo14wr1ip9wk64ar6c',
      zoom: 5.8,
      center: [14, 43],
      minZoom: 5,
      maxZoom: 14,
      maxBounds: bounds
    })

    setMap(newMap)
  }, [])

  useEffect(() => {
    if (!loading && map && map.getSource('places')) {
      map.removeLayer('places-layer')
      map.removeSource('places') // force reload of map features
    }

    if (!loading && map && !map.getSource('places')) {
      var features = mapFeatures.map(p => ({
        'type': 'Feature',
        'properties': {
          'title': p.title,
          'description': p.description,
          'icon': p.type,
          'id': p.id
        },
        'geometry': {
          'type': 'Point',
          'coordinates': [p.positionGPS[0].longitude, p.positionGPS[0].latitude]
        }
      }))

      map.addSource('places', {
        'type': 'geojson',
        'data': {
          'type': 'FeatureCollection',
          'features': features
        }
      })

      map.addLayer({
        'id': 'places-layer',
        'type': 'symbol',
        'source': 'places',
        'layout': {
          'icon-image': 'location_{icon}',
          'icon-allow-overlap': true,
          'icon-offset': [0, -20]
        }
      })

      map.on('click', 'places-layer', function(e) {
        var coordinates = e.features[0].geometry.coordinates.slice()
        var id = e.features[0].properties.id
        animateMapToLocation(map, coordinates)
        setFeature(id)
      })

      map.on('click', function(e) {
        unsetFeature()
      })
    }
  }, [map, mapFeatures, loading])

  return (
    <div className="App-map" ref={mapEl}></div>
  )
}

export default Map